var map = {
	"./modals/user-reset/user-reset.module": [
		"./src/app/modals/user-reset/user-reset.module.ts",
		"common",
		"modals-user-reset-user-reset-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"common",
		"pages-login-login-module"
	],
	"./pages/more/more.module": [
		"./src/app/pages/more/more.module.ts",
		"default~pages-more-more-module~pages-overview-overview-module~pages-statistic-statistic-module",
		"pages-more-more-module"
	],
	"./pages/overview/overview.module": [
		"./src/app/pages/overview/overview.module.ts",
		"default~pages-more-more-module~pages-overview-overview-module~pages-statistic-statistic-module",
		"default~pages-overview-overview-module~pages-statistic-statistic-module",
		"common",
		"pages-overview-overview-module"
	],
	"./pages/register/register.module": [
		"./src/app/pages/register/register.module.ts",
		"common",
		"pages-register-register-module"
	],
	"./pages/statistic/statistic.module": [
		"./src/app/pages/statistic/statistic.module.ts",
		"default~pages-more-more-module~pages-overview-overview-module~pages-statistic-statistic-module",
		"default~pages-overview-overview-module~pages-statistic-statistic-module",
		"pages-statistic-statistic-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;